/**
 * @generated SignedSource<<ecb7a1093b3f9c6d6ac3fd09d638477f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type utils_salesAssociate$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"OutOfStoreListItem_salesAssociate" | "InStoreListItem_salesAssociate" | "MovementsModal_salesAssociate" | "OccurrencesModal_salesAssociate" | "SalesAssociatesContentTemplateItem_salesAssociate">;
  readonly " $fragmentType": "utils_salesAssociate";
};
export type utils_salesAssociate$key = {
  readonly " $data"?: utils_salesAssociate$data;
  readonly " $fragmentSpreads": FragmentRefs<"utils_salesAssociate">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "utils_salesAssociate"
};

(node as any).hash = "2f054fdf22a0d5b2835932743ef0ad17";

export default node;
